module.exports = __webpack_public_path__ + "img/p2-active.3e5d9c85.png";